
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 107 107","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M53.5 1C82.495 1 106 24.505 106 53.5S82.495 106 53.5 106 1 82.495 1 53.5 24.505 1 53.5 1z","stroke":"#0624B4","stroke-width":"2","stroke-dasharray":"15,15"}}),_c('path',{attrs:{"d":"M57.107 53.14l20.226-24.618c2.253-2.742 1.212-4.966-2.327-4.966H32.43c-3.537 0-4.626 2.26-2.428 5.049l19.636 24.908-20.226 24.619c-2.253 2.741-1.212 4.966 2.328 4.966h42.575c3.537 0 4.626-2.261 2.428-5.05L57.107 53.14z","fill":"#0624B4"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/OLT.svg